<template>
  <div>
    <vs-popup :title="$t('WriteAnswer')" :active.sync="showModal">
      <form>
        <vs-textarea
          v-model="currentSuggestion.content"
          :label="$t('TextCriticOrSuggestion')"
          rows="3"
          disabled
        />
        <vs-textarea
          v-model="currentSuggestion.answer"
          :label="$t('Answer')"
          rows="3"
          disabled
        />
      </form>
    </vs-popup>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "",
  props: {
    show: { default: false },
    currentSuggestion: {},
  },
  data() {
    return {
      showError: false,
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
};
</script>
